const chartsState = {
    airflowChart: undefined,
    egressInterfaceChart: undefined,
    egressLockerCharts: undefined,
    egressSiteCharts: undefined,
    humidityChart: undefined,
    ingressInterfaceChart: undefined,
    ingressLockerCharts: undefined,
    ingressSiteCharts: undefined,
    lockerPowerConsumptionChart: undefined,
    powerConsumptionChart: undefined,
    pressureChart: undefined,
    rackPressureChart: undefined,
    rackTemperatureChart: undefined,
    requestingAirflowChart: false,
    requestingEgressInterfaceChart: false,
    requestingEgressLockerCharts: false,
    requestingEgressSiteCharts: false,
    requestingHumidityChart: false,
    requestingIngressInterfaceChart: false,
    requestingIngressLockerCharts: false,
    requestingIngressSiteCharts: false,
    requestingLockerPowerConsumptionChart: false,
    requestingPowerConsumptionChart: false,
    requestingPressureChart: false,
    requestingRackPressureChart: false,
    requestingRackTemperatureChart: false,
    requestingTemperatureChart: false,
    temperatureChart: undefined
};
export default chartsState;
